import React from 'react';
import ItemSkeletonDesk from './ItemSkeletonDesk';
import ItemSkeletonLap from './ItemSkeletonLap';
import ItemSkeletonMobile from './ItemSkeletonMobile';
var AgentListSkeleton = function AgentListSkeleton() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "palm-hide lap-hide"
  }, /*#__PURE__*/React.createElement(ItemSkeletonDesk, null)), /*#__PURE__*/React.createElement("div", {
    className: "palm-hide desk-hide"
  }, /*#__PURE__*/React.createElement(ItemSkeletonLap, null)), /*#__PURE__*/React.createElement("div", {
    className: "desk-hide  lap-hide"
  }, /*#__PURE__*/React.createElement(ItemSkeletonMobile, null)));
};
export default AgentListSkeleton;